import { Button, Tooltip, Typography } from '@mui/material';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import { LoadingButton } from '@mui/lab';
import type { ButtonProps } from '@mui/material';

interface UploadButtonProps extends Omit<ButtonProps, 'onChange'> {
  tooltip: string;
  name?: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const UploadButton = ({ tooltip, name, onChange, ...rest }: UploadButtonProps) => {
  let input: HTMLInputElement | null = null;
  return (
    <>
      <Tooltip
        title={<Typography variant='body2'>{tooltip}</Typography>}
        placement='right'
      >
        <span>
          {name ? (
            <LoadingButton
              {...rest}
              onClick={(e) => {
                e.preventDefault();
                input?.click();
              }}
              endIcon={<UploadFileIcon />}
            >
              {name}
            </LoadingButton>
          ) : (
            <Button
              {...rest}
              onClick={(e) => {
                e.preventDefault();
                input?.click();
              }}
            >
              <UploadFileIcon />
            </Button>
          )}
        </span>
      </Tooltip>
      <input
        ref={(element) => (input = element)}
        hidden
        onChange={(e) => {
          e.preventDefault();
          onChange(e);
        }}
        type='file'
      />
    </>
  );
};
export default UploadButton;

